import { mapState } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'
import { entitiesLimits } from '@/modules/limits'
import {
  SPECIAL_CHARACTERS,
  containsSpecialCharacters
} from '@/utils/validations'

export const featureValidation = {
  mixins: [validationMixin],

  computed: {
    ...mapState('knowledgebase/features', ['features']),

    featureErrors () {
      const errors = {}
      const { name, words } = this.$v.localFeature
      if (name && name.$dirty) {
        if (!name.required) {
          errors.name = this.$t('validations.feature-validation.name.required')
        } else if (!name.unique) {
          errors.name = this.$t('validations.feature-validation.name.unique')
        } else if (!name.specialCharacters) {
          errors.name = this.$t('validations.feature-validation.name.specialCharacters', { specialCharacters: SPECIAL_CHARACTERS.join(' ') })
        } else if (!name.maxLength) {
          errors.name = this.$t('validations.feature-validation.name.maxLength', { maxLength: entitiesLimits.simple.name.max })
        }
      }

      if (words && words.$dirty) {
        if (!words.required) {
          errors.words = this.$t('validations.feature-validation.words.required')
        }
        if (!words.specialCharacters) {
          errors.words = this.$t('validations.feature-validation.words.specialCharacters', { specialCharacters: SPECIAL_CHARACTERS.join(' ') })
        }
      }

      return errors
    },

    $nameRules () {
      const usedFeatureNames = this.features
        .filter(feature => feature.id !== this.localFeature.id)
        .map(feature => feature.name.trim())

      return {
        required,
        maxLength: maxLength(entitiesLimits.list.name.max),
        specialCharacters: value => !containsSpecialCharacters(value),
        unique: name => !usedFeatureNames.some(usedName => usedName === name.trim())
      }
    },

    $wordsRules () {
      return {
        required: words => words.length !== 0,
        specialCharacters: words => !words.some(word => containsSpecialCharacters(word))
      }
    },

    validationRules () {
      return {
        name: this.$nameRules,
        words: this.$wordsRules
      }
    }
  },

  validations () {
    return {
      localFeature: this.validationRules
    }
  }
}
